export default resolveVersion;

function resolveVersion(ctx) {
//TODO: прекратить угадайку
  const mobileWidget = ctx.querySelector('.mobile-megogo-wrapper_v1');

  if (mobileWidget) {
    return 'mobile';
  }

  return 'desktop';
}
